import { P2GBox } from '@parcel2go/core-ui';
import { P2GText } from '@parcel2go/core-ui';

import { PanelButtons } from '../panels/PanelButtons';
import { useTranslation } from 'react-i18next';
import { TranslationNamespaces } from '~/lib/constants';

interface props {
  confirm?: () => void;
  cancel?: () => void;
  affected: number;
  justify: 'left' | 'center';
}

export default function Archive(props: props) {
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);
  return (
    <P2GBox textAlign={props.justify}>
      {props.affected === 1 ? (
        <P2GText>
          {t('ARCHIVE_ITEM_INFO', {
            defaultValue: 'Are you sure you want to archive this item? This can be restored later.'
          })}
        </P2GText>
      ) : (
        <P2GText>
          {t('ARCHIVE_ITEM_INFO', {
            defaultValue: 'Are you sure you want to archive these items? These can be restored later.'
          })}
        </P2GText>
      )}
      <P2GBox mt={1}>
        <PanelButtons
          centralise
          onSave={props.confirm}
          onCancel={props.cancel}
          cancelText={t('NO_CANCEL_BUTTON', { defaultValue: 'No' })}
          saveText={t('YES_BUTTON', { defaultValue: 'Yes' })}
        />
      </P2GBox>
    </P2GBox>
  );
}
